import React, { useState } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Typo from 'constants/typography'
import Radio from 'components/common/radio'
import Button from 'components/common/button'
import { BUTTON_TYPES } from 'constants/button'
import { hasLocizeTranslation } from 'lib/utils/locize'

const AddToBagModalItem = ({
  addToBag,
  addToWaitlist,
  item,
  selected,
  t,
  isComingSoon,
}) => {
  const [localWaitlisted, setLocalWaitListed] = useState(false)
  let rightLabel = ''
  let isNotifyMe = false
  const rightLabelClasses = ['atb-modal__label-right']
  const isOutOfStock = item.stock && item.stock.quantity < 1
  const isOnWaitlist = item.is_on_waitlist || localWaitlisted

  if ((isOutOfStock || isComingSoon) && !isOnWaitlist) {
    rightLabelClasses.push('cta')
    isNotifyMe = true
  } else if (isOnWaitlist) {
    rightLabel = t('Waitlisted')
    rightLabelClasses.push(Typo.body2)
  } else if (item.stock?.is_low_quantity) {
    rightLabel = `${item.stock.quantity} ${t('Left')}`
    rightLabelClasses.push('low-quantity')
    rightLabelClasses.push(Typo.body2)
  }

  return (
    <div className="atb-modal__content">
      <button
        className={clsx('atb-modal__attr', { 'out-of-stock': isOutOfStock })}
        onClick={!isOutOfStock ? (e) => addToBag(e, item) : undefined}
        type="button"
        disabled={isOutOfStock}
      >
        <Radio className="atb-modal__circle" checked={selected} />
        <span className={clsx(Typo.body2, 'atb-modal__label-body')}>
          {item.size}
        </span>
      </button>
      {isNotifyMe ? (
        <Button
          className={clsx(rightLabelClasses)}
          onClick={(e) => addToWaitlist(e, item, setLocalWaitListed)}
          type={BUTTON_TYPES.text}
        >
          <span className={Typo.overline}>
            {isComingSoon
              ? hasLocizeTranslation(t, 'NOTIFY_ME', 'Notify Me')
              : t('Notify Me')}
          </span>
        </Button>
      ) : (
        <span className={clsx(rightLabelClasses)}>{rightLabel}</span>
      )}
    </div>
  )
}

AddToBagModalItem.defaultProps = {
  selected: undefined,
  isComingSoon: false,
}

AddToBagModalItem.propTypes = {
  isComingSoon: PropTypes.bool,
  addToBag: PropTypes.func.isRequired,
  addToWaitlist: PropTypes.func.isRequired,
  item: PropTypes.shape({
    id_product_attribute: PropTypes.number.isRequired,
    is_on_waitlist: PropTypes.bool.isRequired,
    size: PropTypes.string.isRequired,
    stock: PropTypes.shape({
      quantity: PropTypes.number,
      is_low_quantity: PropTypes.bool,
    }).isRequired,
  }).isRequired,
  selected: PropTypes.bool,
  t: PropTypes.func.isRequired,
}

export default AddToBagModalItem
